var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{key:_vm.key},[_c('Header'),_c('v-divider'),_c('div',{staticClass:"main-layout relative d-flex"},[_c('notifications'),_c('Menu',{staticClass:"d-none d-lg-block"}),_c('router-view',{staticClass:"content-view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }